var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 40,
    viewBox: "0 0 116 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.38721 16.5869H5.61662L8.13432 27.6501L11.211 16.5869H13.9485L17.0835 27.6501L19.5963 16.5869H22.8294L18.8932 33.9189H15.7371L12.5623 22.7116L9.44844 33.9189H6.33206L2.38969 16.5869H2.38721Z",
    fill: "#31C1F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1919 16.5868H33.6441V19.7901H27.4573V22.9301H33.6441V26.1297H27.4573V30.6832H33.6441V33.9176H24.1919V16.5856V16.5868Z",
    fill: "#31C1F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8482 16.5868H44.1782L50.8395 33.9188H47.4138L46.0587 30.3391H38.9639L37.5641 33.9188H34.1384L40.8506 16.5868H40.8482ZM42.5188 21.1825L40.1774 27.1358H44.8439L42.5188 21.1825Z",
    fill: "#31C1F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4768 16.5868H60.0843V19.851H56.9133V33.9188H53.5547V19.851H50.4768V16.5868Z",
    fill: "#31C1F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0657 16.5868H64.4255V23.1177H70.2024V16.5868H73.5312V33.9188H70.2024V26.3197H64.4255V33.9188H61.0657V16.5868Z",
    fill: "#31C1F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2986 16.5868H85.7496V19.7901H79.564V22.9301H85.7496V26.1297H79.564V30.6832H85.7496V33.9176H76.2986V16.5856V16.5868Z",
    fill: "#31C1F2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8574 16.5868H91.3676C93.2903 16.5868 94.6591 16.7582 95.4751 17.0998C96.2912 17.4401 96.9458 18.0065 97.4426 18.8002C97.9394 19.5951 98.1866 20.5329 98.1866 21.616C98.1866 22.7537 97.9121 23.7064 97.3643 24.4715C96.8178 25.2354 95.9906 25.8142 94.8876 26.208L98.9865 33.9188H95.3857L91.4794 26.5719H91.1229V33.9188H87.8562V16.5868H87.8574ZM91.1241 23.3661H92.1749C93.2431 23.3661 93.9797 23.2307 94.3809 22.9525C94.7833 22.673 94.9845 22.2147 94.9845 21.5713C94.9845 21.1887 94.8839 20.8608 94.6839 20.5801C94.4864 20.2969 94.2181 20.0957 93.884 19.9727C93.5499 19.8485 92.9363 19.7889 92.0433 19.7889H91.1229V23.3648L91.1241 23.3661Z",
    fill: "#31C1F2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M101.078 13.1375L104.265 12.4655C104.265 12.4655 106.949 15.6527 111.816 13.9747C111.816 13.9747 101.244 45.5173 111.816 29.2423L113.494 30.2497C113.494 30.2497 109.466 38.6387 103.259 37.968C97.0512 37.2972 102.084 28.2375 104.937 15.8204C104.937 15.8204 105.609 14.3113 100.91 14.8156L101.078 13.1375Z",
    fill: "#31C1F2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M113.495 7.85119C113.495 10.3055 111.504 12.2978 109.048 12.2978C106.593 12.2978 104.603 10.3055 104.603 7.85119C104.603 5.39684 106.593 3.40454 109.048 3.40454C111.504 3.40454 113.495 5.39684 113.495 7.85119Z",
    fill: "#31C1F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8560783fc7f0e0634fc9d7bbe205804b.svg";
export { ForwardRef as ReactComponent };